function server() {
  // return "http://localhost/sbus-backend";
  return "https://business.strackit.com/business";
}

function AIServer() {
  // return "http://localhost:8000";
  return "https://ai.strackit.com";
}

export default server;
export { AIServer };
